import { Routes } from '@angular/router'
import { isAuthenticated } from '../../core/auth/guards/auth.guard'

export const salonAdminRoutes: Routes = [
	{
		path: 'salon-admin',
		canActivate: [isAuthenticated],
		loadComponent: () => import('../../layout/main-layout/main-layout'),
		data: {
			role: 'SALON_ADMIN',
			title: 'Salon Admin Dashboard',
			breadcrumb: 'SalonAdmin',
			preload: true,
			roles: ['SALON_ADMIN'],
		},
		children: [
			// {
			// 	path: 'gateways',
			// 	loadComponent: () => import('./gateway-management/gateway-management'),
			// 	title: 'gateways_manage',
			// },

			// Admin Dashboard
			{
				path: 'ad',
				loadComponent: () => import('../ads/ad/ad.component'),
				data: {
					title: 'Admin Dashboard',
					breadcrumb: 'Dashboard',
					icon: 'admin-dashboard',
					preload: true,
					roles: ['SALON_ADMIN'],
				},
			},

			// Base Information Management
			// {
			// 	path: 'goods-category',
			// 	loadComponent: () => import('./baseInformation/goods-category/goods-category'),
			// 	data: {
			// 		title: 'Goods Category',
			// 		breadcrumb: 'Goods Category',
			// 		icon: 'category',
			// 		preload: true,
			// 		roles: ['ADMIN'],
			// 	},
			// },
			// {
			// 	path: 'stock-symbol',
			// 	children: [
			// 		{
			// 			path: '',
			// 			loadComponent: () => import('./baseInformation/stock-symbol/stock-symbol'),
			// 			data: {
			// 				title: 'Stock Symbols',
			// 				breadcrumb: 'Stock Symbols',
			// 				icon: 'stock',
			// 			},
			// 		},
			// 		{
			// 			path: 'add',
			// 			loadComponent: () => import('./baseInformation/stock-symbol/add-stock-symbol/add-stock-symbol'),
			// 			data: {
			// 				title: 'Add Stock Symbol',
			// 				breadcrumb: 'Add Stock',
			// 			},
			// 		},
			// 		{
			// 			path: 'edit/:id',
			// 			loadComponent: () => import('./baseInformation/stock-symbol/add-stock-symbol/add-stock-symbol'),
			// 			data: {
			// 				title: 'Edit Stock Symbol',
			// 				breadcrumb: 'Edit Stock',
			// 			},
			// 		},
			// 	],
			// },
			//
			// // Price Configuration
			// {
			// 	path: 'release-goods-from-warehouse-price-config',
			// 	loadComponent: () =>
			// 		import(
			// 			'./baseInformation/release-goods-from-warehouse-price-config/release-goods-from-warehouse-price-config'
			// 		),
			// 	data: {
			// 		title: 'Release Price Config',
			// 		breadcrumb: 'Release Price',
			// 		icon: 'price-config',
			// 	},
			// },
			// {
			// 	path: 'goods-to-warehousing-price-config',
			// 	loadComponent: () =>
			// 		import('./baseInformation/goods-to-warehousing-price-config/goods-to-warehousing-price-config'),
			// 	data: {
			// 		title: 'Warehousing Price Config',
			// 		breadcrumb: 'Warehousing Price',
			// 		icon: 'warehouse-price',
			// 	},
			// },
			// {
			// 	path: 'lab-analysis-price-config',
			// 	loadComponent: () => import('./baseInformation/lab-analysis-price-config/lab-analysis-price-config'),
			// 	data: {
			// 		title: 'Lab Analysis Price Config',
			// 		breadcrumb: 'Lab Analysis Price',
			// 		icon: 'lab-price',
			// 	},
			// },
			// {
			// 	path: 'legal-users-management',
			// 	loadComponent: () => import('./legal-users-management/legal-users-management'),
			// 	data: {
			// 		roles: ['ADMIN'],
			// 		preload: true,
			// 	},
			// },
			// // User Management
			// {
			// 	path: 'users-management',
			// 	children: [
			// 		{
			// 			path: '',
			// 			loadComponent: () => import('./user-management/user-management'),
			// 			data: {
			// 				title: 'Users Management',
			// 				breadcrumb: 'Users',
			// 				icon: 'users',
			// 				preload: true,
			// 				roles: ['ADMIN'],
			// 			},
			// 		},
			// 		{
			// 			path: 'add',
			// 			loadComponent: () => import('./user-management/add-user/add-user'),
			// 			data: {
			// 				title: 'Add User',
			// 				breadcrumb: 'Add User',
			// 			},
			// 		},
			// 		{
			// 			path: 'edit/:id',
			// 			loadComponent: () => import('./user-management/add-user/add-user'),
			// 			data: {
			// 				title: 'Edit User',
			// 				breadcrumb: 'Edit User',
			// 			},
			// 		},
			// 	],
			// },
			// {
			// 	path: 'money-request',
			// 	children: [
			// 		{
			// 			path: '',
			// 			loadComponent: () => import('./money-request/money-request'),
			// 			data: {
			// 				title: 'Users Management',
			// 				breadcrumb: 'Users',
			// 				icon: 'users',
			// 				preload: true,
			// 				roles: ['ADMIN'],
			// 			},
			// 		},
			// 	],
			// },
			// {
			// 	path: 'money-wallet-pay-by-id',
			// 	children: [
			// 		{
			// 			path: '',
			// 			loadComponent: () => import('./money-wallet-pay-by-id/money-wallet-pay-by-id'),
			// 			data: {
			// 				title: 'Users Management',
			// 				breadcrumb: 'Users',
			// 				icon: 'users',
			// 				preload: true,
			// 				roles: ['ADMIN'],
			// 			},
			// 		},
			// 	],
			// },
			//
			// // Reports
			// {
			// 	path: 'money-wallet',
			// 	loadComponent: () => import('./reports/admin/money-wallet/money-wallet'),
			// 	data: {
			// 		title: 'Money Wallet Report',
			// 		breadcrumb: 'Money Wallet',
			// 		icon: 'wallet-report',
			// 		preload: true,
			// 		roles: ['ADMIN'],
			// 	},
			// },
			// {
			// 	path: 'trade',
			// 	loadComponent: () => import('./reports/admin/trade/trade'),
			// 	data: {
			// 		title: 'Trade Report',
			// 		breadcrumb: 'Trade Report',
			// 		icon: 'trade-report',
			// 		preload: true,
			// 		roles: ['ADMIN'],
			// 	},
			// },
			// {
			// 	path: 'orders',
			// 	loadComponent: () => import('./reports/admin/orders/orders'),
			// 	data: {
			// 		title: 'Orders Report',
			// 		breadcrumb: 'Orders Report',
			// 		icon: 'orders-report',
			// 		preload: true,
			// 		roles: ['ADMIN'],
			// 	},
			// },
			//
			// // Agreement Templates
			// {
			// 	path: 'agreement-templates',
			// 	loadComponent: () =>
			// 		import('./admin/agreement-templates/agreement-templates').then(m => m.AgreementTemplatesComponent),
			// 	data: {
			// 		title: 'Agreement Templates',
			// 		breadcrumb: 'Agreements',
			// 		icon: 'agreement',
			// 	},
			// },

			// Goods Management (shared with trading)
			// {
			// 	path: 'good-to-warehouse',
			// 	loadComponent: () => import('./goods-management/good-to-warehouse'),
			// 	data: {
			// 		title: 'Good to Warehouse',
			// 		breadcrumb: 'Good to Warehouse',
			// 		icon: 'goods-warehouse',
			// 		preload: true,
			// 		roles: ['ADMIN'],
			// 	},
			// },
			// {
			// 	path: 'good-to-warehouse/goods-bundle-lab-analysis/:goodsToWarehouseId',
			// 	loadComponent: () => import('./goods-management/goods-bundle-lab-analysis-list/goods-bundle-lab-analysis-list'),
			// 	data: {
			// 		title: 'Lab Analysis',
			// 		breadcrumb: 'Lab Analysis',
			// 	},
			// },
			// User Profile
			{
				path: 'profile',
				loadComponent: () => import('../trading/profile/profile'),
				data: {
					title: 'Profile',
					breadcrumb: 'Profile',
					icon: 'user',
				},
			},
			// Default redirect
			{
				path: '',
				redirectTo: 'admin-dashboard',
				pathMatch: 'full',
			},
		],
	},
]
